import React from 'react';
import PropTypes from 'prop-types';
import useSettingsContext from '../../context/useSettingsContext';

function News(props) {
  const {
    postType,
  } = useSettingsContext();


  const {post} = props;
  let publisher

  News.propTypes = {
    post: PropTypes.object
  }

  if ( post.acf?.publication_name ) {
    publisher = <p className="news-card__publisher">{post.acf.publication_name}</p>
  }

  return (
    <div className={'related-news__card'}>
      <article id={`${postType}-${post.id}`} className="news-card">
        <div className="news-card__content">
          {publisher}
          <h3 className="news-card__heading">
            <a href={post.link} className="news-card__heading-link" dangerouslySetInnerHTML={{__html: post.title.rendered}} />
          </h3>
        </div>
        <div className="news-card__link">
          <a href={post.link} target="_self" className="c-btn c-btn-tertiary c-btn-color-normal c-btn-icon c-btn-tertiary--reverse">
            <i className="icon-chev-right"></i>
            <span className="c-btn-text">Read more</span>
          </a>
        </div>
      </article>
    </div>
  );
}

export default News;
